import * as React from 'react';
import { Title } from 'library/ui';

export default function SignUpLoginHeader({ children }: { children: React.ReactNode }) {
    return <Title size="h1">{children}</Title>;
}
